import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = {
  key: 0,
  class: "posAb",
  style: {"width":"18px","top":"-10px","right":"0px"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "pointer fl" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "mc fs10"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 mr4",
  style: {}
}, "必須出席者に変更", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 0,
  role: "button",
  class: "fl mt6 mr20 mr4"
}
const _hoisted_14 = {
  key: 1,
  role: "button",
  class: "fl mt6 mr20 mr4"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt6 fs12",
  style: {"width":"150px"}
}, "このメンバーのみを出席者にする", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 mr4",
  style: {}
}, "日程決定者に追加", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fl mt5 mr20 mr4",
  style: {}
}, "出席者に追加", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_ctx.mem)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isViewTypeMail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                width: "22",
                height: "22",
                class: "fr pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteSendUser()))
              }, null, 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Dropdown, {
          ref: "dropdown",
          id: "userIconSendMenu",
          style: {}
        }, {
          dropdown: _withCtx(() => [
            (_ctx.isViewTypeMail && _ctx.memType == `option`)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: "fs12 pointer pad10",
                  style: {"width":"200px"},
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeList && _ctx.changeList(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/user_black.png`),
                    width: "21",
                    height: "22",
                    class: "fl mr5 mt2",
                    style: {}
                  }, null, 8, _hoisted_9),
                  _hoisted_10,
                  _hoisted_11
                ]))
              : _createCommentVNode("", true),
            (_ctx.memType == `require`)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 1,
                  class: "fs12 pointer pad10",
                  style: {"width":"200px"},
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeList && _ctx.changeList(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/change.png`),
                    width: "21",
                    height: "22",
                    class: "fl mr5 mt4 ml1",
                    style: {}
                  }, null, 8, _hoisted_12),
                  (_ctx.isViewTypeMail)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, "任意出席者に変更"))
                    : (_openBlock(), _createElementBlock("p", _hoisted_14, "出席者からはずす")),
                  _hoisted_15
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isViewTypeMail && [`require`, `notAttendee`].includes(_ctx.memType))
              ? (_openBlock(), _createElementBlock("li", {
                  key: 2,
                  class: "fs12 pointer pad10",
                  style: {"width":"200px"},
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onlyAttend && _ctx.onlyAttend(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/change.png`),
                    width: "21",
                    height: "22",
                    class: "fl mr5 mt4 ml1",
                    style: {}
                  }, null, 8, _hoisted_16),
                  _hoisted_17,
                  _hoisted_18
                ]))
              : _createCommentVNode("", true),
            (_ctx.isViewTypeMail)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 3,
                  class: "fs12 pointer pad10",
                  style: {"width":"200px"},
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addFixMember && _ctx.addFixMember(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/waaq_members.png`),
                    width: "22",
                    height: "16",
                    class: "fl mr5 mt4",
                    style: {}
                  }, null, 8, _hoisted_19),
                  _hoisted_20,
                  _hoisted_21
                ]))
              : _createCommentVNode("", true),
            (_ctx.memType == `notAttendee`)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 4,
                  class: "fs12 pointer pad10",
                  style: {"width":"200px"},
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changeList && _ctx.changeList(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/waaq_members.png`),
                    width: "22",
                    height: "16",
                    class: "fl mr5 mt4",
                    style: {}
                  }, null, 8, _hoisted_22),
                  _hoisted_23,
                  _hoisted_24
                ]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createElementVNode("li", {
              class: "dropdown-toggle centered fs12 w100 rad20",
              style: {"background-color":"transparent","border":"none","appearance":"none","padding":"0","outline":"none","list-style":"none"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickMember && _ctx.clickMember(...args)))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_UserIcon, {
                  member: _ctx.mem,
                  width: 45,
                  canEdit: false,
                  updateSelf: false,
                  showTooltip: _ctx.viewType == `mail` ? true : false,
                  tooltipWithEmail: true
                }, null, 8, ["member", "showTooltip"]),
                _hoisted_5,
                (_ctx.Util.isPresent(_ctx.mem.name))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.truncate(_ctx.mem.name, 6)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/home/arrow_down.png`),
                width: "18",
                height: "18",
                class: "fl mt14",
                style: {"margin-left":"-2px"}
              }, null, 8, _hoisted_7),
              _hoisted_8
            ])
          ]),
          _: 1
        }, 512)
      ]))
    : _createCommentVNode("", true)
}